import router from './routers'
import store from '@/store'
import Config from '@/settings'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken } from '@/utils/auth' // getToken from cookie
import { filterAsyncRouter } from '@/store/modules/permission'

NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/login', '/scanQRcode', '/orderInfoByQRcode', '/activity', '/pdaScanQrcode','/scanGroupCardQrcode', '/groupCardInfo', '/scanSpeialBillQrcode', '/speialBillInfo', '/inspectionApp','/hmInspectionApp','/dlInspectionApp','/gbInspectionApp','/mwInspectionApp','/faInspectionApp']// no redirect whitelist

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    if(to.meta.title == '扫码出场-订单详情' || to.meta.title == '扫码出场' || to.meta.title == '智慧停车统计'){
      document.title = to.meta.title
    } else {
      document.title = to.meta.title + ' - ' + Config.title
    }
  }
  NProgress.start()
  if (getToken()) {
    // 已登录且要跳转的页面是登录页
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    }else if(to.path === '/parkingSetting/cloudSentryBox'){
      window.open('https://'+window.location.hostname+'/pcSentryBox/#/index', true)
      NProgress.done()
    }else{
      if (store.getters.loadMenus) {
        // ★ 登录后优先走此分支（Login action 已设置 loadMenus=true）
        // 避免重复调用 GetInfo 接口，减少偶发导航失败
        store.dispatch('updateLoadMenus').then(() => {})
        loadMenus(next, to)
      } else if (store.getters.roles.length === 0) {
        // 刷新页面等场景：roles 为空且 loadMenus 为 false，需要重新拉取用户信息
        store.dispatch('GetInfo').then(() => {
          loadMenus(next, to)
        }).catch((err) => {
          console.log(err)
          store.dispatch('LogOut').then(() => {
            location.reload()
          })
        })
      } else {
        next()
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

export const loadMenus = (next, to) => {
  const menuList = store.getters.user.menuList || []
  const rulesRouter = []

  menuList.forEach(router => {
    const Level_1 = {}
    Level_1.name = router.fullName
    Level_1.path = '/' + router.enCode
    Level_1.meta = { title: router.fullName, icon: router.icon, noCache: false }
    if (router.type === 1 && router.hasChildren) {
      Level_1.component = 'Layout'
      Level_1.alwaysShow = true
    }
    
    if (router.type === 2 && !router.hasChildren) {
      Level_1.component = 'Layout'
      Level_1.alwaysShow = false
      Level_1.children=[{
        name : router.fullName,
        path : 'index',
        meta : { title: router.fullName, icon: router.icon, noCache: false },
        component : router.urlAddress === '' ? '/' : router.urlAddress
      }]
    }
    if (router.hasChildren) {
      Level_1.children = []
      router.children.forEach(child => {
        const Level_2 = {}
        Level_2.name = child.fullName
        Level_2.path = child.enCode
        Level_2.meta = { title: child.fullName, icon: child.icon, noCache: false }
        Level_2.component = child.urlAddress === '' ? '/' : child.urlAddress

        if (child.hasChildren) {
          Level_2.children = []
          child.children.forEach(grandson => {
            const Level_3 = {}
            Level_3.name = grandson.fullName
            Level_3.path = grandson.enCode
            Level_3.meta = { title: grandson.fullName, icon: grandson.icon, noCache: false }
            Level_3.component = grandson.urlAddress === '' ? '/' : grandson.urlAddress
            Level_2.children.push(Level_3)
          })
        }

        Level_1.children.push(Level_2)
      })
    }

    rulesRouter.push(Level_1)
  })

  const asyncRouter = filterAsyncRouter(rulesRouter)
  asyncRouter.push({ path: '*', redirect: '/404', hidden: true })

  store.dispatch('GenerateRoutes', asyncRouter).then(() => { // 存储路由
    // router.addRoutes(asyncRouter) // 动态添加可访问路由表
    asyncRouter.forEach((res) => {
      router.addRoute(res)
    })
    next({ ...to, replace: true })
  })
}

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
